import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69d27d7734b9ae00149db1c5/karfin/src/components/AboutSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69d27d7734b9ae00149db1c5/karfin/src/components/EMICalculator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69d27d7734b9ae00149db1c5/karfin/src/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69d27d7734b9ae00149db1c5/karfin/src/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69d27d7734b9ae00149db1c5/karfin/src/components/PartnersSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69d27d7734b9ae00149db1c5/karfin/src/components/ProductsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69d27d7734b9ae00149db1c5/karfin/src/components/StatsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69d27d7734b9ae00149db1c5/karfin/src/components/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/69d27d7734b9ae00149db1c5/karfin/src/components/VideoTestimonialsSection.tsx");
